module.exports = __webpack_public_path__ + "img/csak_janos.3fcbc74f.png";